import React, { Component } from 'react';

import { ContentCell, CustomTableCell } from './Cell.styles';

class Cell extends Component {
  render() {
    const { colSpan, children, special, align, className, maxWidth, noEllipsis } = this.props;
    return (
      <CustomTableCell className={className} colSpan={colSpan}>
        <ContentCell special={special} align={align} maxWidth={maxWidth} noEllipsis={noEllipsis}>
          {children}
        </ContentCell>
      </CustomTableCell>
    );
  }
}

export default Cell;
